import type { PrescriptionItem } from './types';

/** "1 tablet · oral · 3 times a day · 5 days · qty 15 tablets" */
export function itemLine(i: PrescriptionItem): string {
  const parts = [i.dose, i.route, i.frequency];
  if (i.durationDays) parts.push(`${i.durationDays} days`);
  parts.push(`qty ${i.quantity}${i.unit ? ` ${i.unit}` : ''}`);
  return parts.filter(Boolean).join(' · ');
}
